module.exports = __webpack_public_path__ + "img/youtube-logo-o.d1471f18.svg";